import React from 'react';
import $ from 'jquery';
import CreatableSelect from 'react-select/creatable';
import linkify from 'linkify-it';
import { validateEmailInputText } from '../../utilities/validateEmail';
import { addSuccessMessage } from '../../utilities/notificationUtilities';
import { EVENTS } from '../../utilities/CONSTANTS';

class EmailMenu extends React.Component {
    constructor(props) {
        super(props);

        this.linkify = linkify();

        this.state = {
            errorMessage: '',
            enableButton: false,
            subject: this.props.page.title,
            message: '',
            buttonText: 'Email page',
            statusText: '',
            emailOptionsLoaded: typeof window._referencableTettraUsers !== 'undefined',
            emailOptions: window._referencableTettraUsers && window._referencableTettraUsers.map(({ email: label, email: value }) => ({ label, value })),
            emailInputValue: '',
            messageValid: true,
        };

        window.addEventListener(EVENTS.USERS_LOADED, () => {
            this.setState({
                emailOptionsLoaded: true,
                emailOptions: window._referencableTettraUsers.map(({ email: label, email: value }) => ({ label, value })),
            });
        });
    }

    handleEmailChange = (newValue, actionMeta) => {
        const emailInputValue = newValue;
        if (newValue === null || newValue.length === 0) {
            this.setState({ emailInputValue, enableButton: false });
        } else {
            this.setState({ emailInputValue, enableButton: true });
        }
    };

    onSubjectChange = (e) => {
        const subject = e.target.value;
        this.setState({ subject });
    };

    onMessageChange = (event) => {
        const message = event.target.value;

        let valid = true;
        if (this.linkify.test(message)) {
            valid = false;
        }

        this.setState({ message, messageValid: valid });
    };

    sendEmail = () => {
        const {
            subject, message, enableButton, emailInputValue, messageValid,
        } = this.state;
        if (enableButton && messageValid) {
            const buttonText = 'Sending...';
            const enableButton = false;
            this.setState({ buttonText, enableButton });
            const { page } = this.props;
            const { teamId } = window;
            const emailAddresses = emailInputValue.map(({ value }) => (value));
            const _token = csrfToken;

            const URL = `/api/teams/${teamId}/pages/${page.id}/shares`;
            $.post(URL, {
                emailAddresses, subject, message, _token,
            })
                .then(response => {
                    if (response.success) {
                        addSuccessMessage(`You just emailed "${page.title}" to: ${emailAddresses.join(', ')}`);
                        this.close();
                    } else {
                        const { setErrorMessage } = this.props;
                        const errorMessage = response.message ?? 'Email failed. Please ensure the addresses are valid, and contact us if problems continue.';
                        setErrorMessage(errorMessage);
                        this.setState({ buttonText: 'Email page', enableButton: true });
                    }
                })
                .catch(response => {
                    // laravel is supposed to detect when a request is AJAX and send a nicer format, but that isn't working here
                    let error = 'Email failed. Please ensure the addresses are valid, and contact us if problems continue.';
                    if (undefined !== response.responseJSON && undefined !== response.responseJSON.errors) {
                        if (undefined !== response.responseJSON.errors.message && undefined !== response.responseJSON.errors.message[0]) {
                            error = response.responseJSON.errors.message[0];
                        } else if (undefined !== response.responseJSON.errors.subject && undefined !== response.responseJSON.errors.subject[0]) {
                            error = response.responseJSON.errors.subject[0];
                        }
                    }

                    const { setErrorMessage } = this.props;
                    setErrorMessage(error);
                    this.setState({ buttonText: 'Email page', enableButton: true });
                });
        }
    };

    validateEmailInput = (inputValue, selectValue, selectOptions) => validateEmailInputText(inputValue);

    noOptionsText = () => 'No match';

    formatLabelText = (userInput) => `Add email: ${userInput}`;

    close = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    };

    render() {
        const {
            subject, enableButton, buttonText, statusText, emailOptions, emailOptionsLoaded, messageValid,
        } = this.state;
        const btnDisabledClass = enableButton && messageValid ? '' : 'is-disabled';

        return (
            <div className="mt2">
                <h4>Share with</h4>
                {!emailOptionsLoaded
                    ? (<div className="loading gray">Loading users</div>)
                    : (
                        <CreatableSelect
                            isMulti
                            formatCreateLabel={this.formatLabelText}
                            noOptionsMessage={this.noOptionsText}
                            isValidNewOption={this.validateEmailInput}
                            onChange={this.handleEmailChange}
                            options={emailOptions}
                            placeholder="someone@example.com"
                        />
                    )}
                <h4>Subject</h4>
                <input className="block col-12 mb2 field" type="text" value={subject} onChange={this.onSubjectChange} />
                <h4>Your message</h4>
                <textarea className="field col-12" placeholder="optional" onChange={this.onMessageChange} />
                {!messageValid
                    && (
                        <p className="warning-message">
                        Message cannot contain links
                        </p>
                    )}
                <div className="mt3 right-align">
                    <span className="left green">{statusText}</span>
                    <span className="react-modal-close btn-secondary mr1" onMouseDown={this.close}>Close</span>
                    <span onMouseDown={this.sendEmail} className={`btn btn-primary ${btnDisabledClass}`}>{buttonText}</span>
                </div>
            </div>
        );
    }
}

export default EmailMenu;
